const DetailVideoViewComponent = ({ video }) => {
    
    return (
        <div className="detailView">>
            <video  autoPlay loop>
                <source src={video} type="video/mp4"/>
            </video>
        </div>
    );
};

export default DetailVideoViewComponent;